import { CollectionFloorPriceChangePeriod } from "@anaconda/core/nft-collection/collection/types"

const DATE_FORMATTER_BY_PERIOD: Record<
  CollectionFloorPriceChangePeriod,
  (date: string) => string
> = {
  [CollectionFloorPriceChangePeriod.HOUR]: (date) =>
    formatTime(date, {
      hour: "2-digit",
      minute: "2-digit",
    }),
  [CollectionFloorPriceChangePeriod.DAY]: (date) =>
    formatDate(date, {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    }),
  [CollectionFloorPriceChangePeriod.WEEK]: (date) =>
    formatDate(date, {
      month: "short",
      day: "numeric",
    }),
  [CollectionFloorPriceChangePeriod.MONTH]: (date) =>
    formatDate(date, {
      month: "short",
      day: "numeric",
    }),
  [CollectionFloorPriceChangePeriod.HALF_YEAR]: (date) =>
    formatDate(date, {
      month: "short",
      day: "numeric",
    }),
  [CollectionFloorPriceChangePeriod.YEAR]: (date) =>
    formatDate(date, {
      month: "short",
      day: "numeric",
    }),
}

const APPROXIMATE_DATE_LABEL_WIDTH_BY_PERIOD: Record<
  CollectionFloorPriceChangePeriod,
  number
> = {
  [CollectionFloorPriceChangePeriod.HOUR]: 70,
  [CollectionFloorPriceChangePeriod.DAY]: 100,
  [CollectionFloorPriceChangePeriod.WEEK]: 70,
  [CollectionFloorPriceChangePeriod.MONTH]: 70,
  [CollectionFloorPriceChangePeriod.HALF_YEAR]: 70,
  [CollectionFloorPriceChangePeriod.YEAR]: 70,
}

const formatTime = (date: string, options: Intl.DateTimeFormatOptions) =>
  new Date(date).toLocaleTimeString("en-US", options)

const formatDate = (date: string, options: Intl.DateTimeFormatOptions) =>
  new Date(date).toLocaleDateString("en-US", options)

export function getDateFormatter(period: CollectionFloorPriceChangePeriod) {
  return DATE_FORMATTER_BY_PERIOD[period]
}

export function getApproximateDateLabelWidth(
  period: CollectionFloorPriceChangePeriod,
) {
  return APPROXIMATE_DATE_LABEL_WIDTH_BY_PERIOD[period]
}
